import {
    Component,
    OnInit,
    ElementRef,
    Renderer2,
    AfterViewInit,
} from '@angular/core';
import { gsap } from 'gsap';

@Component({
    selector: 'app-follow-cursor',
    templateUrl: './follow-cursor.component.html',
})
export class FollowCursorComponent implements OnInit, AfterViewInit {
    x: number = 0;
    y: number = 0;
    scale: number = 1;
    hoverScale: number = 1.1;
    enableTilt: boolean = true;

    private cursorFollower!: HTMLElement;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit(): void {
        this.cursorFollower =
            this.el.nativeElement.querySelector('#cursor-follower');
    }

    ngAfterViewInit(): void {
        this.setupEventListeners();
    }

    setupEventListeners(): void {
        this.renderer.listen('window', 'mousemove', (event: MouseEvent) => {
            if (this.enableTilt) {
                this.x = event.clientX;
                this.y = event.clientY;
                this.moveCursorFollower();
            }
        });

        this.renderer.listen(this.cursorFollower, 'mouseenter', () => {
            this.scale = this.hoverScale;
            this.moveCursorFollower();
        });

        this.renderer.listen(this.cursorFollower, 'mouseleave', () => {
            this.scale = 1;
            this.moveCursorFollower();
        });
    }

    moveCursorFollower(): void {
        gsap.to(this.cursorFollower, {
            x: this.x,
            y: this.y,
            scale: this.scale,
            duration: 0.8,
            ease: 'power2.out',
        });
    }
}
